const API_BASE = '/api'

// Get stored token
const getToken = () => localStorage.getItem('authToken')

// Helper with auth
const fetchWithAuth = async (url, options = {}) => {
  const token = getToken()
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  })

  if (response.status === 401) {
    localStorage.removeItem('authToken')
    window.location.href = '/login'
    return
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Network error' }))
    throw new Error(error.message || 'Something went wrong')
  }

  return response.json()
}

// Auth APIs
export const authAPI = {
  login: async (pin) => {
    const response = await fetch(`${API_BASE}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pin }),
    })
    if (!response.ok) {
      const error = await response.json()
      throw new Error(error.message)
    }
    return response.json()
  },

  logout: async () => {
    return fetchWithAuth(`${API_BASE}/auth/logout`, { method: 'POST' })
  },
}

// Expense APIs
export const expenseAPI = {
  getAll: async (params = {}) => {
    const query = new URLSearchParams(params).toString()
    return fetchWithAuth(`${API_BASE}/expenses?${query}`)
  },

  create: async (data) => {
    return fetchWithAuth(`${API_BASE}/expenses`, {
      method: 'POST',
      body: JSON.stringify(data),
    })
  },

  update: async (id, data) => {
    return fetchWithAuth(`${API_BASE}/expenses/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    })
  },

  delete: async (id) => {
    return fetchWithAuth(`${API_BASE}/expenses/${id}`, { method: 'DELETE' })
  },

  getSummary: async (params = {}) => {
    const query = new URLSearchParams(params).toString()
    return fetchWithAuth(`${API_BASE}/expenses/summary?${query}`)
  },
}

// Budget APIs
export const budgetAPI = {
  get: async (month) => {
    return fetchWithAuth(`${API_BASE}/budget/${month}`)
  },

  set: async (data) => {
    return fetchWithAuth(`${API_BASE}/budget`, {
      method: 'POST',
      body: JSON.stringify(data),
    })
  },
}

// Wishlist APIs
export const wishlistAPI = {
  getAll: async (status = 'active') => {
    return fetchWithAuth(`${API_BASE}/wishlists?status=${status}`)
  },

  create: async (data) => {
    return fetchWithAuth(`${API_BASE}/wishlists`, {
      method: 'POST',
      body: JSON.stringify(data),
    })
  },

  update: async (id, data) => {
    return fetchWithAuth(`${API_BASE}/wishlists/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    })
  },

  delete: async (id) => {
    return fetchWithAuth(`${API_BASE}/wishlists/${id}`, { method: 'DELETE' })
  },

  markPurchased: async (id) => {
    return fetchWithAuth(`${API_BASE}/wishlists/${id}/purchase`, { method: 'PATCH' })
  },
}
